import styled from 'styled-components'

export const StyleLogoutMessage = styled.div`
  font-weight: 400;
  line-height: 22px;
  color: #595959;
  padding: 8px 0 10px;
`
